<template>
<div>
  <div class="vx-row" v-if="item">
    <div class="vx-col w-full lg:w-1/1">

      <!-- ABOUT CARD -->
      <vx-card :title="`Detail ${$i18n.t('PurchaseOrderCustomer')}`" class="mb-base">
        <!-- ACTION SLOT -->
        <template slot="actions">
          <div style="display: flex; align-items: center; justify-content: center;">
            <vs-button color="primary" class="mr-3" icon-pack="feather" icon="icon-edit" @click="edit">
              {{$i18n.t('Edit')}}
            </vs-button>
            <vs-button color="danger" icon-pack="feather" icon="icon-arrow-left" type="border" @click="$router.push({ name: 'purchase' })">
              {{$i18n.t('Back')}}
            </vs-button>
          </div>
        </template>

        <div class="vx-row">
          <div class="vx-col w-full lg:w-1/2" v-for="(cell, i) in cells" :key="i">
            <div class="mt-5">
              <h6 class="font-bold mb-2">{{ cell.header }}</h6>
              <p style="line-height: 1.5;">{{ item[cell.field] }}</p>
            </div>
          </div>
        </div>


      </vx-card>

      <vx-card :title="$i18n.t('Spesification')" style="margin-bottom: 60px;">

        <vs-table :data="item.specifications">

          <template slot="thead">
            <vs-th>Name</vs-th>
            <vs-th class="text-center">Qty</vs-th>
            <vs-th class="text-right">Price</vs-th>
            <vs-th class="text-right">Total</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">

              <vs-td :data="data[indextr].name">
                {{ data[indextr].name }}
              </vs-td>

              <vs-td :data="data[indextr].qty" class="text-center">
                {{ data[indextr].qty }}
              </vs-td>

              <vs-td :data="data[indextr].price" class="text-right">
                <span style="float: left;">{{ currencies[data[indextr].currency-1].text }}</span>
                <span style="letter-spacing: 1.2px;">{{ formatNumber(data[indextr].price) }}</span>
              </vs-td>

              <vs-td :data="data[indextr].total" class="text-right">
                <span style="float: left;">{{ currencies[data[indextr].currency-1].text }}</span>
                <span style="letter-spacing: 1.2px;">{{ formatNumber(data[indextr].price * data[indextr].qty) }}</span>
              </vs-td>

            </vs-tr>
            <vs-tr style="background: #8080;">
              <vs-td colspan="3" class="text-right" style="font-weight: bold;">Sub Total</vs-td>
              <vs-td style="font-weight: bold; letter-spacing: 1.2px;" class="text-right">
                {{ total(data) }}
              </vs-td>
            </vs-tr>
            <vs-tr style="background: #8080;">
              <vs-td colspan="3" class="text-right" style="font-weight: bold;">Diskon</vs-td>
              <vs-td style="font-weight: bold; letter-spacing: 1.2px;" class="text-right">
                {{ diskon(item) }}
              </vs-td>
            </vs-tr>
            <vs-tr style="background: #8080;">
              <vs-td colspan="3" class="text-right" style="font-weight: bold;">Total</vs-td>
              <vs-td style="font-weight: bold; letter-spacing: 1.2px;" class="text-right">
                {{ grandTotal(data, item) }}
              </vs-td>
            </vs-tr>
          </template>

        </vs-table>

      </vx-card>

    </div>
  </div>
</div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "IncomingLetterDetail",
  data: () => ({
    currencies: [
      {
        text: 'USD',
        value: '1'
      },
      {
        text: 'EUR',
        value: '2'
      },
      {
        text: 'IDR',
        value: '3'
      }
    ],
  }),
  computed: {
    ...mapGetters({
      item: 'purchase/showItem'
    }),
    cells () {
      return [
        {
          header: this.$i18n.t('Date'),
          field: 'tanggal_display'
        },
        {
          header: this.$i18n.t('PONumber'),
          field: 'nomor'
        },
        {
          header: this.$i18n.t('POContactNumber'),
          field: 'no_kontrak'
        },
        {
          header: this.$i18n.t('CustomerName'),
          field: 'nama_customer'
        },
        {
          header: this.$i18n.t('ProjectName'),
          field: 'nama_proyek'
        },
        {
          header: this.$i18n.t('DONumber'),
          field: 'delivery_order'
        },
        {
          header: this.$i18n.t('SN'),
          field: 'sn'
        },
      ]
    }
  },
  methods: {
    edit () {
      this.$router.push({ name: 'purchase-edit', params: { id: this.$route.params.id } });
    },
    diskon (data) {
      let curr = 'IDR';

      this.currencies
        .map(currency => {
          if (currency.value == data.currency_diskon)
            curr = currency.text
        });

      return `${curr} ${this.formatNumber(data.diskon)}`;
    },
    grandTotal (data, items) {
      let currencies = this.currencies
        .map(currency => {
          currency.total = data.filter(item => item.currency == currency.value).map(item => parseFloat(item.price) * parseFloat(item.qty));
          return currency;
        })
        .filter(currency => currency.total.length > 0)
        .map(currency => {
          currency.total = currency.total.reduce((total, item) => total += item);
          return `${currency.text} ${this.formatNumber(currency.total - items.diskon)}`;
        });

      return currencies.join(' + ');
    },
    total (data) {
      let currencies = this.currencies
        .map(currency => {
          currency.total = data.filter(item => item.currency == currency.value).map(item => parseFloat(item.price) * parseFloat(item.qty));
          return currency;
        })
        .filter(currency => currency.total.length > 0)
        .map(currency => {
          currency.total = currency.total.reduce((total, item) => total += item);
          return `${currency.text} ${this.formatNumber(currency.total)}`;
        });

      return currencies.join(' + ');
    },
    formatNumber (value) {
      let val = (value/1).toFixed(2).replace('.', ',');
      let result = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

      return result;
    }
  },
  created () {
    this.id = this.$secure.decrypt(this.$route.params.id);
    this.$store.dispatch('purchase/detailItem', { id: this.id });
  }
}
</script>

<style scoped>

</style>
